import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from "./styles.module.scss";
import CheckBox from "app/components/inputs/CheckBox";

export type MinimalBookingOption = { id: number; title: string };

interface BookingOptionSelectorProps {
  bookingOptions: MinimalBookingOption[];
  value: MinimalBookingOption[];
  onChange: (bookingOptionIds: MinimalBookingOption[]) => void;
}

export default function BookingOptionSelector(props: BookingOptionSelectorProps) {
  const { bookingOptions, value, onChange } = props;

  const { t } = useTranslation();
  const [showBookingOptions, setShowBookingOptions] = useState(value.length > 0);

  const handleBookingOptionChange = (checked: boolean, bookingOption: MinimalBookingOption) => {
    let ids = [...value];
    if (checked) {
      ids.push(bookingOption);
    } else {
      ids = ids.filter(opt => opt.id !== bookingOption.id);
    }
   onChange(ids);
  };

  return (
    <div className={styles.booking_option_selection}>
      <div className={styles.header} onClick={() => setShowBookingOptions(!showBookingOptions)}>
        <h2>{t("Limit Available Booking Options")}</h2>
        <i className={`ico ico-chevron ${showBookingOptions ? styles.open : ''}`} />
      </div>
      <div style={{ display: showBookingOptions ? '' : 'none' }}>
        <p className={styles.info}>{t("Uncheck booking options that should NOT be available during this schedule.")}</p>
        <p>{t("Booking Options")}</p>
        <ul className={styles.booking_options_list}>
          {bookingOptions.map(bookingOption => {
            return (
              <li key={bookingOption.id}>
                <CheckBox
                  className={styles.booking_option}
                  key={bookingOption.id}
                  name={`booking-option-${bookingOption.id}`}
                  label={bookingOption.title}
                  checked={value.map(bo => bo.id).includes(bookingOption.id)}
                  onChange={(checked) => handleBookingOptionChange(checked, bookingOption)}
                  squareCheckIcons
                />
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
